export const getCorrectMaxCount = (isPhoneSmallWidth, isPhoneWidth, isTabletWidth) => {
    if (isPhoneSmallWidth) {
        return 2;
    }
    else if (isPhoneWidth) {
        return 3;
    }
    else if (isTabletWidth) {
        return 5;
    }
    else {
        return 7;
    }
};
